import CreateTariffFormValuePart from './CreateTariffFormValuePart';

export default CreateTariffFormValuePart;
